<template>
  <div class="container-midia" @click="selecionarMidia">
    <v-img v-if="!midia.url" src="/images/avatares/avatar-padrao.png" class="card-midia" aspect-ratio="4/3"/>
    <v-img v-else :src="createUrl(midia.url)" class="card-midia" aspect-ratio="4/3" lazy-src="/images/loading.gif"/>
    <div class="container-midia-info">
      <label class="max-label">{{ midia.nome }}</label>
    </div>
  </div>
</template>

<script>
export default {
    name: 'cardMidia',
    props: {
        midia: {
            type: Object,
            required: true
        },
        index: Number
    },
    methods: {
        selecionarMidia() {
            this.$emit('selecionarMidia', this.index)
        }
    }
}
</script>

<style scoped lang="stylus">

.container-midia
  border-radius 6px
  border 1px solid #ccc

.container-midia:hover
  cursor pointer
  box-shadow 0 5px 5px rgba(0, 0, 0, 0.2)

.card-midia
  width 100%
  height 120px
  object-fit cover

.container-midia-info
  padding 10px
  background-color #ffffff
  border-radius 0 0 6px 6px
  overflow hidden

  label
    font-size 14px
    color #000000

.container-midia-info > label:hover
  cursor pointer

.max-label
  display inline-block
  max-width 100%
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

</style>